import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import React from 'react'
import { v7 } from 'uuid'

const Faq: React.FC = () => {
  const config = useReduxSelector(selectConfig)
  const { t } = useTranslation('onePage')
  const { push } = useHistory()

  if (!config?.faq) return null
  return (
    <div className='onePage__faq'>
      <h1>{t('frequentlyAskedQuestions')}</h1>
      <div className='onePage__faq__main'>
        {config.faq.map((item, idx) => <details
          key={idx}
          open={!idx}>
          <summary>{item.title}</summary>
          <p dangerouslySetInnerHTML={{ __html: item.content }} />
        </details>)}
      </div>
      <BackBtn
        text={t('contactUs')}
        action={() => {
          push(`/chat/${v7()}`)
        }}
      />
    </div>
  )
}

export default Faq